<template>
    <div class="ei-num-list">
        <ei-num :end="+item" v-for="(item,index) in numList" :key="index"></ei-num>
    </div>
</template>

<script>
    export default {
        name: "EiNumList",
        data() {
            return {
                numList: []
            }
        },
        props: {
            num: {
                type: String,
                required: true
            }
        },
        watch: {
            num(newValue,oldValue) {
                this.numList = newValue.replace(/(.)(?=[^$])/g, "$1,").split(",")
            }
        },
        created() {
            this.numList = this.num.replace(/(.)(?=[^$])/g, "$1,").split(",")
        }
    }
</script>

<style scoped>

</style>
